<template>
  <section class="privacy-content py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-10 mx-auto">
          <IntroductionSection />
          <DataControllerSection />
          <DataCollectedSection />
          <LegalBasisSection />
          <ProcessingMethodsSection />
          <DataRetentionSection />
          <DataSharingSection />
          <CookiesSection />
          <SecuritySection />
          <UserRightsSection />
          <MinorsSection />
          <PolicyChangesSection />
          <ContactsSection />

          <PrivacySection>
            <PrivacyFooter />
          </PrivacySection>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PrivacySection from '@/components/privacy/PrivacySection.vue'
import PrivacyFooter from '@/components/privacy/content/PrivacyFooter.vue'
import IntroductionSection from '@/components/privacy/content/IntroductionSection.vue'
import DataControllerSection from '@/components/privacy/content/DataControllerSection.vue'
import DataCollectedSection from '@/components/privacy/content/DataCollectedSection.vue'
import LegalBasisSection from '@/components/privacy/content/LegalBasisSection.vue'
import ProcessingMethodsSection from '@/components/privacy/content/ProcessingMethodsSection.vue'
import DataRetentionSection from '@/components/privacy/content/DataRetentionSection.vue'
import DataSharingSection from '@/components/privacy/content/DataSharingSection.vue'
import CookiesSection from '@/components/privacy/content/CookiesSection.vue'
import SecuritySection from '@/components/privacy/content/SecuritySection.vue'
import UserRightsSection from '@/components/privacy/content/UserRightsSection.vue'
import MinorsSection from '@/components/privacy/content/MinorsSection.vue'
import PolicyChangesSection from '@/components/privacy/content/PolicyChangesSection.vue'
import ContactsSection from '@/components/privacy/content/ContactsSection.vue'

export default {
  name: 'PrivacyContent',
  components: {
    PrivacySection,
    PrivacyFooter,
    IntroductionSection,
    DataControllerSection,
    DataCollectedSection,
    LegalBasisSection,
    ProcessingMethodsSection,
    DataRetentionSection,
    DataSharingSection,
    CookiesSection,
    SecuritySection,
    UserRightsSection,
    MinorsSection,
    PolicyChangesSection,
    ContactsSection
  }
}
</script>

<style scoped>
.privacy-content {
  background-color: #f8f9fa;
}
</style>

